import React, { useRef } from "react"
import { graphql } from "gatsby"
import { useInView } from "framer-motion"

import { Layout } from "../../components/layout"
import { MetaHead } from "../../components/layout/meta-head"
import HeroMedia from "../../components/HeroMedia/HeroMedia"
import Card from "../../components/Card/Card"
import SlideWithTwoMedia from "../../components/SlideWithTwoMedia"
import Testimonial from "../../components/Testimonial/Testimonial"
import BlogInterest from "../../components/BlogInterest/BlogInterest"
import { Container } from "../../components/Container"
import ContactForm from "../../components/ContactForm"
import ServiceInquiry from "../../components/ServiceInquiry"

import "./index.css"

export default function SingleOtherPage({ data = {} }){
    const post = data.contentfulOtherPages
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    return (
        <Layout isHeaderDark={post.isHeaderDark} languagePreference={post.languagePreference} isDefaultHeader={true}>
            <div className="page--light page-global-landing">
                <HeroMedia isDark={post.isHeaderDark} translation={post.translation} link={post.heroMediaLink} title={post.heroTitle} singleImage={post.singleImage} singleImgLink={post.heroSingleImageLink} multipleLogos={post.multipleSmallLogos} bgPosition={post.heroMediaPosition}/>
                <Card infoTilesContent={post.infoTiles} hasIconCaret={true} isOverFlow={true} />
                <SlideWithTwoMedia content={post} />
                {post.serviceInquiryQueue !== null && <ServiceInquiry content={post} serviceInquiryQueue={post.serviceInquiryQueue} />}
                <div className="partial-global-contact">
                    <ContactForm pageName={`${post.pageTitle}`} languageVal={post.languagePreference} />
                </div>
                <div ref={ref} className="blog-list-picker" style={{ opacity: isInView ? 1 : 0, transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s" }}>
                    <Container>
                        <BlogInterest content={post.blogListPicker} title={post.blogTitle} />
                    </Container>
                </div>
                <Testimonial content={post} clientHighlight={post.clientHighlight} />  
            </div>
        </Layout>
    )
}

export const query = graphql`
    query ($slug: String!) {
        contentfulOtherPages(slug: { eq: $slug }) {
            slug
            isHeaderDark
            languagePreference
            pageTitle
            seoTitle
            tags
            metaDescription {
                metaDescription
            }
            thumbnailImage
            translation {
                buttonName
                buttonLink
            }
            heroMediaPosition
            heroMediaLink
            heroTitle
            heroSingleImageLink
            singleImage {
                mediaName
                mediaVisibility
                mediaPosition
                media {
                    gatsbyImageData(width: 2400, quality: 100) 
                }
            }
            multipleSmallLogos {
                gatsbyImageData(width: 60)
            }
            slideFirstMediaTitle
            slideFirstMedia
            slideLastMediaTitle
            slideLastMedia
            servicesInquiryTitle
            servicesInquiryDescription {
                servicesInquiryDescription
            }
            serviceInquiryQueue {
                title
                description { description }
                buttonConfig {
                    buttonName
                    buttonLink
                    isNoFollow
                }
            }
            testimonialTitle
            infoTiles {
                title 
                subTitle
                description { description }
                image { gatsbyImageData(width: 2400, quality: 100) }
                link
                buttonConfig {
                    buttonName
                    buttonLink
                    isNoFollow
                }
            }
            seoContentSlider {
                title
                content {
                    content
                }
                media {
                    gatsbyImageData(width: 2400, quality: 100)
                }
                mediaLink
            }
            clientHighlight {
                name
                image { gatsbyImageData(width: 2400, quality: 100) }
                videoLink
            }
            blogTitle
            blogListPicker {
                blogPostUrlSlug
            }
        }
    }
`

export const Head = ({data}) => <MetaHead title={data.contentfulOtherPages.pageTitle} description={data.contentfulOtherPages.metaDescription.metaDescription} titleSEO={data.contentfulOtherPages.seoTitle} tags={data.contentfulOtherPages.tags} seoImage={data.contentfulOtherPages.thumbnailImage} slugUrl={`https://www.savorbrands.com/page/${data.contentfulOtherPages.slug}/`} />